<template>
<div class="[ c-island c-island--large@lg ] t-background-white-grey t-margin-bottom-s">
	<h2 class="t-text-style-beta">Grunduppgifter</h2>
	<!-- Mode: view -->
	<template v-if="dataMode === 'view'">
		<div class="t-background-white-grey">
			<div class="c-island t-margin-top-s  t-margin-bottom-s  t-background-white">
				<div class="o-grid o-grid--no-flex">
					<div class="o-grid__column" data-size="s:12 sm:11">
						<div class="o-grid">
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Namn</span>
									<p class="c-basic-information__content">{{firstName}} {{surName}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Personnummer</span>
									<p class="c-basic-information__content">{{personalIdentityNumber}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Anställningsnummer</span>
									<p class="c-basic-information__content">{{employeeNumber}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Anställningsdatum</span>
									<p class="c-basic-information__content">{{employmentDate ? formatDate(employmentDate) : ''}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Email</span>
									<p class="c-basic-information__content">{{email}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Roll</span>
									<p class="c-basic-information__content">{{role}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Körkortsklass</span>
									<p class="c-basic-information__content">{{drivingLicense}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="sm:12 md:4 lg:4">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Arbetsställe</span>
									<p class="c-basic-information__content">{{(workplace && workplace.attributes ? workplace.attributes.name : '')}}</p>
								</div>
							</div>
							<div class="o-grid__column" data-size="s:12 sm:12">
								<div class="c-basic-information__wrapper t-margin-bottom-s">
									<span class="c-basic-information__label">Grundutbildning, examensår</span>
									<p class="c-basic-information__content s-text" v-html="education"></p>
								</div>
							</div>
							<div class="o-grid__column" data-size="s:12 sm:12">
								<div class="c-basic-information__wrapper">
									<span class="c-basic-information__label">Erfarenhet</span>
									<p class="c-basic-information__content s-text t-margin-bottom-none" v-html="experience"></p>
								</div>
							</div>
						</div>
					</div>
					<div class="o-grid__column  t-text-align-right  t-margin-top-s@s" data-size="s:12 sm:1">
						<button v-if="$can('manage', 'CompetenceCard')" 
							type="button" 
							class="c-button c-button--linkstyle c-button--reset"
							@click="goToEditMode">Ändra</button>
					</div>
				</div>
			</div>
		</div>
	</template>
	<template v-if="dataMode === 'create' || dataMode === 'edit'">
		<form @submit.prevent="handleSubmit" class="c-form  t-margin-top-s">
			<fieldset>
				<div class="o-grid">
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<vue-input label="Förnamn" input-id="firstName" :value="firstName" ref="firstName"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<vue-input label="Efternamn" input-id="surName" :value="surName" ref="surName"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<personal-identity-number-input label="Personnummer (ååmmdd-nnnn)" input-id="personalIdentityNumber" :value="personalIdentityNumber" ref="personalIdentityNumber" :required="false"></personal-identity-number-input>
						</div>
					</div>
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<vue-input label="Anställningsnummer" input-id="employeeNumber" :value="employeeNumber" ref="employeeNumber" :required="false"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<date-input label="Anställningsdatum (åååå-mm-dd)" input-id="employmentDate" :value="employmentDate" ref="employmentDate" :required="false"></date-input>
						</div>
					</div>
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<vue-input type="email" label="Email" input-id="email" :value="email" ref="email"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<vue-input label="Roll" input-id="role" :value="role" ref="role" :required="false"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:6 lg:6" class="o-grid__column">
						<div class="c-form__item">
							<vue-input label="Körkortsklass" input-id="drivingLicense" :value="drivingLicense" ref="drivingLicense" :required="false"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:12 lg:12" class="o-grid__column">
						<dropdown-variations label="Välj arbetsställe" :item-groups="workplaceOptions" :value="{ id: (workplace) ? workplace.id : '', name: (workplace && workplace.attributes) ? workplace.attributes.name : ''}" ref="workplace" :disabled="dataMode ==='edit'" :filterable="true"></dropdown-variations>
					</div>
					<div data-size="sm:12 md:12 lg:12" class="o-grid__column t-margin-top-s">
						<div class="c-form__item">
							<vue-input label="Grundutbildning, examensår" input-id="education" :value="education" ref="education" type="textarea" :required="false"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:12 lg:12" class="o-grid__column">
						<div class="c-form__item">
							<vue-input label="Erfarenhet" input-id="experience" :value="experience" ref="experience" type="textarea" :required="false"></vue-input>
						</div>
					</div>
					<div data-size="sm:12 md:12 lg:12" class="o-grid__column">
						<div class="t-margin-bottom-xs t-margin-top-xs t-text-align-right">
							<router-link v-if="dataMode === 'create'" class="c-button c-button--linkstyle c-button--reset" to="/">Avbryt</router-link>
							<button type="submit" v-if="dataMode === 'create'" class="c-button c-button--primary" @click="setSubmitType('create')">Spara</button>
							<button v-if="dataMode === 'edit'" type="button" class="c-button c-button--linkstyle c-button--reset" @click.prevent="cancelEditCompetenceCard">Avbryt</button>
							<button v-if="dataMode === 'edit'" type="submit" class="c-button c-button--primary" @click="setSubmitType('edit')">Spara</button>
						</div>
					</div>
				</div>
			</fieldset>
		</form>
	</template>
</div>
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import DateInput from '@/components/vue-components/date-input/DateInput.vue';
import PersonalIdentityNumberInput from '@/components/vue-components/personal-identity-number-input/PersonalIdentityNumberInput.vue';
import DropdownVariations from '@/components/vue-components/dropdown-variations/DropdownVariations.vue';
export default {
  name: 'BasicInformation',
  components: {
		VueInput,
		DateInput,
		PersonalIdentityNumberInput,
		DropdownVariations
	},
	props: {
		mode: {
      type: String,
      default: 'view',
    },
		id: {
			type: String,
			default: '0'
		},
		firstName: {
			type: String,
			default: ''
		},
		surName: {
			type: String,
			default: ''
		},
		personalIdentityNumber: {
			type: String,
			default: ''
		},
		employeeNumber: {
			type: String,
			default: ''
		},
		employmentDate: {
			type: String,
			default: ''
		},
		email: {
			type: String,
			default: ''
		},
		role: {
			type: String,
			default: ''
		},
		drivingLicense: {
			type: String,
			default: ''
		},
		workplace: {
			type: Object,
			default: () => {}
		},
		experience: {
			type: String,
			default: ''
		},
		education: {
			type: String,
			default: ''
		},
		workplaceOptions: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			dataMode: this.mode,
		}
	},
	methods: {
		setSubmitType(type) {
      this.submitType = type;
		},
		handleSubmit() {
      switch (this.submitType) {
        case 'create':
          this.create();
					break;
				case 'edit':
					this.edit();
					break;
      }
		},
		create() {
			const firstName = this.$refs.firstName.getValue();
			const surName = this.$refs.surName.getValue();
			const personalIdentityNumber = this.$refs.personalIdentityNumber.getValue();
			const employeeNumber = this.$refs.employeeNumber.getValue();
			const employmentDate = this.$refs.employmentDate.getValue();
			const email = this.$refs.email.getValue();
			const role = this.$refs.role.getValue();
			const drivingLicense = this.$refs.drivingLicense.getValue();
			const workplace = this.$refs.workplace.getValue();
			const experience = this.$refs.experience.getValue();
			const education = this.$refs.education.getValue();
			
			this.$emit('create', {
				firstName: firstName,
				surName: surName,
				personalIdentityNumber: personalIdentityNumber,
				employeeNumber: employeeNumber,
				employmentDate: employmentDate,
				email: email,
				role: role,
				drivingLicense: drivingLicense,
				workplaceId: workplace.id,
				experience: experience,
				education: education
			});
		},
		edit() {			
			this.$emit('edit', {
				id: this.id,
				firstName: this.$refs.firstName.getValue(),
				surName: this.$refs.surName.getValue(),
				personalIdentityNumber: this.$refs.personalIdentityNumber.getValue(),
				employeeNumber: this.$refs.employeeNumber.getValue(),
				employmentDate: this.$refs.employmentDate.getValue(),
				email: this.$refs.email.getValue(),
				role: this.$refs.role.getValue(),
				drivingLicense: this.$refs.drivingLicense.getValue(),
				experience: this.$refs.experience.getValue(),
				education: this.$refs.education.getValue()
			});

			this.goToViewMode();
		},
		goToEditMode() {
			this.dataMode = 'edit';
		},
		goToViewMode() {
			this.dataMode = 'view';
		},
		cancelEditCompetenceCard() {
			this.goToViewMode();
		},
		formatDate(employmentDate) {
			const dateString = new Date(employmentDate).toLocaleDateString('sv-SE');
			return dateString;
		},
	}
}
</script>
